import type { ChangeEvent, FC } from "react";
import { InputGroup } from "./input_group";
import { CheckboxButton } from "./checkbox_button";

export type LanguageOption = { code: string; label: string };

type FormLanguageSelectorProps = {
  value: string[];
  onChange: (languages: string[]) => void;
  label: string;
  languageOptions: LanguageOption[];
  error?: string;
  required?: boolean;
  optionWrapperClassName?: string;
};

export const FormLanguageSelector: FC<FormLanguageSelectorProps> = ({
  value,
  onChange,
  label,
  languageOptions,
  error,
  required,
  optionWrapperClassName,
}) => (
  <InputGroup
    label={label}
    required={required}
    error={!!error}
    errorMessage={error}
  >
    <div className={`mt-2 flex space-x-4 ${optionWrapperClassName ?? ""}`}>
      {languageOptions.map((lang) => (
        <CheckboxButton
          key={lang.code}
          checked={value.includes(lang.code)}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            if (e.target.checked) {
              onChange([...value, lang.code]);
            } else {
              onChange(value.filter((l) => l !== lang.code));
            }
          }}
          label={lang.label}
          value={lang.code}
        />
      ))}
    </div>
  </InputGroup>
);
